import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import settings from "../../config/settings";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import { changeLanguage } from '../../store/actionCreators/profileSettings';
import '../../assets/stylesheets/ProfileSlide/ProfileLanguage.scss';

const activeLanguage = ["en", "ar", "fr", "pt", "it"];

const Language = ({  }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stateSelectedLanguage = useSelector(state => state.selectedLanguage);
    const defaultLangValue = localStorage.language || stateSelectedLanguage;
    const [selectedLanguage, selectLanguage] = useState(defaultLangValue);
    const setLanguage = (lang) => {
        if(activeLanguage.includes(lang))
            selectLanguage(lang);
    };

    const confirmLanguage = () => {
        dispatch(changeLanguage(selectedLanguage));
    }

    return (
        <div className={'languageSection'}>
            <div className={`header`}>
                <span className={'title'}>{t('settings.language')}</span>
                <Link className={'closeButton'} to={'/settings'}>
                    <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left closeButton">
                    </FontAwesomeIcon>
                </Link>
            </div>
            <div>
                <div className="languageContentWrapper">
                    <div className={'languageContent'}>
                        {
                            settings.languages.map((lang, index) => <div key={index} className={`languageSelector ${selectedLanguage === lang ? 'selectedLang' : ''}`}>
                                <div className={`languageFlag ${lang}-flag  ${activeLanguage.includes(lang) ? '' : 'comingSoon'}`}></div>
                                <span className={'label'}>{t(`language.${lang}`)}</span>
                                <div className={'clickableMask'} onClick={() => setLanguage(lang)}></div>
                            </div>)
                        }
                    </div>
                </div>
                <div className="dialogConfirmBox">
                    <button className="primary" onClick={confirmLanguage}>{t('settings.select')}</button>
                </div>
            </div>
        </div>
    )
};


export default Language;
